import {z} from 'zod';

import {isNumber, isPositive} from 'ramda-adjunct';

import i18n from '@dms/i18n';

const orderItemSchema = z.object({
  id: z.string(),
  ratio: z.number().min(0).max(100).nullish(),
  variant: z.string().nullish(),
});

const newOrderItemSchema = z
  .object({
    ratio: z.number().min(0).max(100).nullish(),
    variant: z.string().nullish(),
  })
  .refine(
    (data) => {
      const isValid = isNumber(data.ratio) && isPositive(data.ratio);

      // If ratio is positive, variant must exist
      if (isValid) {
        return !!data.variant;
      }

      return true;
    },
    {
      message: i18n.t('general.validations.fieldIsRequired'),
      path: ['variant'],
    }
  );

export const goodwillFormSchema = z.object({
  orders: z.array(orderItemSchema),
  newOrders: z.array(newOrderItemSchema),
});

export type GoodwillFormType = z.infer<typeof goodwillFormSchema>;
